<template>
    <b-card no-body>
        <b-card-header class="p-2">
            <h4 class="mb-0 font-weight-bolder">
                <span>تراکنش ها</span>
                <feather-icon @click="$bvModal.show('modal-transaction-description')" size="21" icon="HelpCircleIcon"
                    class="text-muted ml-75 pointer" />
            </h4>
            <h5 @click="$router.push(`/advanced-sales-report`)" class="mb-0 text-info pointer">
                گزارش جامع
            </h5>
        </b-card-header>
        <hr class="m-0">
        <div class="d-flex flex-row flex-wrap justify-content-between align-items-center px-2 my-1">
            <div class="d-flex align-items-center flex-shrink-0 mb-1 mb-md-50">
                <h4 class="mb-0">تعداد : </h4>
                <div class="d-flex align-items-center ml-25">
                    <h4 class="mb-0 font-weight-bolder">
                        {{ salesAnalytics.totalOrdersCount.toLocaleString('fa-IR') }}
                    </h4>
                    <h5 class="mb-0 ml-25">تراکنش</h5>
                </div>
            </div>
            <div class="d-flex align-items-center flex-shrink-0 mb-1 mb-md-50">
                <h4 class="mb-0">مبلغ : </h4>
                <div class="d-flex align-items-center ml-25">
                    <h4 class="mb-0 font-weight-bolder">
                        {{ salesAnalytics.totalOrdersAmount.toLocaleString('fa-IR') }}
                    </h4>
                    <h5 class="mb-0 ml-25">ریال</h5>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <div style="width: 330px;">
                <vue-apex-charts :options="data.options" :series="data.series" />
            </div>
        </div>
        <div class="px-2 pb-2 pt-1">
            <h4 class="mb-75">مجموع مبلغ فروش</h4>
            <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0" style="color: #50E3C2;">همراهِ همیشگی</h5>
                <div class="d-flex align-items-center ml-25">
                    <h4 class="mb-0" style="color: #50E3C2;">
                        {{ customerAnalytics.groups[0].totalOrdersAmount.toLocaleString('fa-IR') }}
                    </h4>
                    <h5 class="mb-0 ml-25" style="color: #50E3C2;">ریال</h5>
                </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-75">
                <h5 class="mb-0" style="color: #ffd057;">همراهِ هفتگی</h5>
                <div class="d-flex align-items-center ml-25">
                    <h4 class="mb-0" style="color: #ffd057;">
                        {{ customerAnalytics.groups[1].totalOrdersAmount.toLocaleString('fa-IR') }}
                    </h4>
                    <h5 class="mb-0 ml-25" style="color: #ffd057;">ریال</h5>
                </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-75">
                <h5 class="mb-0" style="color: #ffb446;">همراهِ ماهانه</h5>
                <div class="d-flex align-items-center ml-25">
                    <h4 class="mb-0" style="color: #ffb446;">
                        {{ customerAnalytics.groups[2].totalOrdersAmount.toLocaleString('fa-IR') }}
                    </h4>
                    <h5 class="mb-0 ml-25" style="color: #ffb446;">ریال</h5>
                </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-75">
                <h5 class="mb-0" style="color: #4A90E2;">لبه‌ی فراموشی</h5>
                <div class="d-flex align-items-center ml-25">
                    <h4 class="mb-0" style="color: #4A90E2;">
                        {{ customerAnalytics.groups[3].totalOrdersAmount.toLocaleString('fa-IR') }}
                    </h4>
                    <h5 class="mb-0 ml-25" style="color: #4A90E2;">ریال</h5>
                </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-75">
                <h5 class="mb-0" style="color: #847ad9;">مشتریان خاموش</h5>
                <div class="d-flex align-items-center ml-25">
                    <h4 class="mb-0" style="color: #847ad9;">
                        {{ customerAnalytics.groups[4].totalOrdersAmount.toLocaleString('fa-IR') }}
                    </h4>
                    <h5 class="mb-0 ml-25" style="color: #847ad9;">ریال</h5>
                </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-75">
                <h5 class="mb-0" style="color: #838383;">خارج از باشگاه</h5>
                <div class="d-flex align-items-center ml-25">
                    <h4 class="mb-0" style="color: #838383;">
                        {{ salesAnalytics.ordersWithoutCustomerAmount.toLocaleString('fa-IR') }}
                    </h4>
                    <h5 class="mb-0 ml-25" style="color: #838383;">ریال</h5>
                </div>
            </div>
        </div>

        <!------------------------------- modal transaction description ------------------------------->
        <b-modal id="modal-transaction-description" title="تراکنش ها" centered :hide-footer="true"
            title-class="font-weight-bolder" size="md">
            <div class="p-75">
                <p v-for="(item, index) in description" :key="index">
                    {{ item }}
                </p>
            </div>
        </b-modal>
    </b-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { BCard, BButton, BRow, BCol, BCardHeader, BModal } from 'bootstrap-vue';
export default {
    name: 'pieChart',
    components: {
        VueApexCharts,
        BCardHeader,
        BCard,
        BButton,
        BRow,
        BCol,
        BModal
    },
    props: {
        customerAnalytics: {
            type: Object,
            default: () => { },
        },
        salesAnalytics: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            description: [
                'تعداد : تعداد کل تراکنش ها.',
                'مبلغ : مبلغ کل تراکنش ها.',
                'همراهِ همیشگی : مشتریانی که تقریباً هر روز خرید می‌کنند.',
                'همراهِ هفتگی : مشتریانی که تقریباً هفته‌ای یک‌بار خرید می‌کنند.',
                'همراهِ ماهانه : مشتریانی که تقریباً هر ماه یک یا دو بار خرید می‌کنند.',
                'لبه‌ی فراموشی : مشتریانی که تقریباً هر سه ماه یک یا دو بار خرید می‌کنند.',
                'مشتریان خاموش : مشتریانی که بیش از سه ماه است خریدی نداشته‌اند.',
                'خارج از باشگاه : مشتریانی که عضو باشگاه نیستند.',
            ],
            data: {
                series: [
                    this.customerAnalytics.groups[0].ordersPercentage,
                    this.customerAnalytics.groups[1].ordersPercentage,
                    this.customerAnalytics.groups[2].ordersPercentage,
                    this.customerAnalytics.groups[3].ordersPercentage,
                    this.customerAnalytics.groups[4].ordersPercentage,
                    this.salesAnalytics.ordersWithoutCustomerPercentage,
                ],
                options: {
                    chart: {
                        width: '100%',
                        type: 'donut',
                    },
                    labels: ['همراهِ همیشگی', 'همراهِ هفتگی', 'همراهِ ماهانه', 'لبه‌ی فراموشی', 'مشتریان خاموش', 'خارج از باشگاه'],
                    colors: [
                        '#50E3C2',
                        '#ffd057',
                        '#ffb446',
                        '#4A90E2',
                        '#847ad9',
                        '#838383'
                    ],
                    legend: {
                        show: false
                    },
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontSize: '16px',
                            fontWeight: 600,
                        },
                        formatter: function (val) {
                            return val.toFixed(0) + "%";
                        },
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return '%' + val.toLocaleString('fa-IR');
                            }
                        },
                        style: {
                            fontSize: '16px'
                        },
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                size: '50%'
                            }
                        }
                    },
                    responsive: [{
                        breakpoint: 768,
                        options: {
                            chart: {
                                width: '100%',
                            },
                        }
                    }]
                },
            },

        }
    },
}
</script>